<template>
    <div class="animated fadeIn">
        <kgr-empty-data
            v-if="trainerAppointments.length === 0"
            :value="$t('offering.noResults')"
        />
        <table
            v-show="trainerAppointments.length > 0"
            vue:is="kgr-table"
            class="kgr-table kgr-table--striped kgr-table--block data-table table-groups"
            searching="false"
            ordering="false"
            :is-data-table="undefined"
            ref="table"
        >
            <thead>
                <tr class="kgr-table__offering">
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('appointment.instructor')"
                        sortable
                        data-sort-field="appointment.instructor"
                    >
                        {{ $t('offering.instructor') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('offering.customId')"
                        sortable
                        data-sort-field="offering.customId"
                    >
                        {{ $t('offering.customerId') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('offering.title')"
                        sortable
                        data-sort-field="offering.title"
                    >
                        {{ $t('offering.title') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('appointment.start')"
                        sortable
                        data-sort-field="appointment.start"
                    >
                        {{ $t('Start') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('appointment.end')"
                        sortable
                        data-sort-field="appointment.end"
                    >
                        {{ $t('Ende') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('appointment.canceled')"
                        sortable
                        data-sort-field="appointment.canceled"
                    >
                        {{ $t('appointment.canceled') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Vertretung für') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('offering.sport')"
                        sortable
                        data-sort-field="offering.sport"
                    >
                        {{ $t('offering.sports') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        :class="getSortClass('offering.category')"
                        sortable
                        data-sort-field="offering.category"
                    >
                        {{ $t('offering.offeringCategory') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Trainerlizenzen') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="trainerAppointment in trainerAppointments"
                    :key="trainerAppointment.id"
                    class="kgr-table__row kgr-table__offering kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        <a
                            :href="employeeUrl(trainerAppointment.instructor.id)"
                            class="kgr-link"
                        >
                            {{ trainerAppointment.instructor.name }}
                        </a>
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.offering.key }}
                    </td>
                    <td class="kgr-table__cell">
                        <span v-if="trainerAppointment.offering.isEditable">
                            <a
                                :href="offeringUrlView(trainerAppointment.offering)"
                                class="kgr-link"
                            >
                                {{ trainerAppointment.offering.title }}
                            </a>
                            <a
                                class="kgr-table__action"
                                :href="offeringUrlEdit(trainerAppointment.offering)"
                                style="position: relative; top: 5px; right: -10px;"
                            >
                                <kgr-icon
                                    icon-class="edit"
                                    small
                                />
                            </a>
                        </span>
                        <div v-else>
                            {{ trainerAppointment.offering.title }}
                        </div>
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.appointment.start }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.appointment.end }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.appointment.canceled ? $t('Ja') : $t('Nein') }}
                    </td>
                    <td class="kgr-table__cell">
                        <a
                            v-for="originalInstructor in trainerAppointment.appointment.originalInstructors"
                            :key="originalInstructor.id"
                            :href="employeeUrl(originalInstructor.id)"
                            class="kgr-link"
                        >
                            {{ originalInstructor.fullName }}
                        </a>
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.offering.sport?.name ?? '' }}
                    </td>
                    <td class="kgr-table__cell">
                        <template v-if="trainerAppointment.offering.category">
                            <span>{{ getCategoryName(trainerAppointment.offering.category.name) }}</span><br />
                            <span>({{ getOfferingMode(trainerAppointment.offering) }})</span>
                        </template>
                    </td>
                    <td class="kgr-table__cell">
                        {{ trainerAppointment.instructor.licenses }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import Icon from '../common/icon/Icon.vue';
import Offering from '../../js/dto/offering/Offering';
import OfferingCategory from '../../js/dto/offering/OfferingCategory'

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-empty-data': EmptyData,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        trainerAppointments: {
            type: Array,
            required: true,
        },
        sortField: {
            type: String,
            required: false,
            default: 'appointment.instructor',
        },
        sortDirection: {
            type: String,
            required: false,
            default: 'asc',
        },
    },
    emits : ['sort'],
    mounted() {
        const table = this.$refs.table;
        const sortableHeaders = table.querySelectorAll('th[sortable]');

        sortableHeaders.forEach((th) => {
            th.addEventListener('click', (e) => {
                e.stopImmediatePropagation();

                const field = th.dataset.sortField;
                let newDirection = 'asc';
                if (this.sortField === field) {
                    newDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }

                this.$emit('sort', { field, direction: newDirection });
            }, true);
        });

        window.setupDataTable(this.$refs.table);
    },

    methods: {
        getSortClass(field) {
            if (this.sortField === field) {
                return this.sortDirection === 'asc' ? 'sorting_asc' : 'sorting_desc';
            }
            return 'sorting';
        },
        getCategoryName(categoryName) {
            if (OfferingCategory.isDefault(categoryName)) {
                return this.$t('offering.' + categoryName);
            }
            return categoryName;
        },
        getOfferingMode(offering) {
            if (offering.bookingMode === Offering.BOOKING_MODE_OFFERING) {
                return this.$t('offering.bookingModeOptions.offeringShort');
            } else {
                return this.$t('offering.bookingModeOptions.appointment');
            }
        },
        employeeUrl(employeeId) {
            return `/backend/employees/${employeeId}/trainer-appointments`;
        },
        offeringUrlView(offering) {
            return this.offeringUrl(offering, 'view');
        },
        offeringUrlEdit(offering) {
            return this.offeringUrl(offering, 'edit');
        },
        offeringUrl(offering, type) {
            if (offering.category && offering.category.name === OfferingCategory.DEFAULT_COURSE) {
                return `/backend/clubs/${this.clubId}/course-offerings/${offering.id}/${type}`;
            } else if (offering.category && offering.category.name === OfferingCategory.DEFAULT_TRAINING) {
                return `/backend/clubs/${this.clubId}/training-offerings/${offering.id}/${type}`;
            } else if (offering.category && offering.category.name === OfferingCategory.DEFAULT_EXAM) {
                return `/backend/clubs/${this.clubId}/exam-offerings/${offering.id}/${type}`;
            } else {
                return `/backend/clubs/${this.clubId}/generic-offerings/${offering.id}/${type}`;
            }
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
table.kgr-table th {
    white-space: nowrap;
}
</style>

